import { Card, CardContent, CardHeader } from '@/components/ui/card'
import type { PieDatumNV } from '@/types/backend'
import { ResponsivePie } from '@nivo/pie'
import React from 'react'

type BilanCategoriesProps = {
  data: PieDatumNV[]
  emptyMsg?: string
}

const BilanCategories: React.FC<BilanCategoriesProps> = ({
  data,
  emptyMsg = 'Aucune donnée de catégories.',
}) => {
  const pieData: PieDatumNV[] = data?.length
    ? data
    : [{ id: '-', label: '-', value: 1 }]
  const isEmpty = !data?.length
  return (
    <Card className='min-h-[360px]'>
      <CardHeader>
        <h4 className='text-lg font-medium'>Quantités par catégorie</h4>
      </CardHeader>
      <CardContent className='h-[300px]'>
        <ResponsivePie<PieDatumNV>
          data={pieData}
          margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
          innerRadius={0.5}
          padAngle={0.5}
          cornerRadius={2}
          activeOuterRadiusOffset={8}
          enableArcLabels={false}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor='#6b7280'
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: 'color' }}
          theme={{
            tooltip: { container: { fontSize: 12, borderRadius: 8 } },
          }}
          tooltip={({ datum }) => (
            <div className='rounded-md border dark:bg-primary bg-white p-2 text-xs shadow'>
              <div>
                Catégorie: <b>{String(datum.label)}</b>
              </div>
              <div>
                Quantité: <b>{datum.value}</b>
              </div>
            </div>
          )}
          arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
        />
        {isEmpty && (
          <div className='mt-2 text-center text-xs text-muted-foreground'>
            {emptyMsg}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default BilanCategories
